/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { PencilIcon } from '@heroicons/react/solid';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main/TweetyWidget';
import { toHeaderCase } from 'js-convert-case';

const SwalWithBootstrapButtons = withReactContent(
    Swal.mixin({
        customClass: {
            confirmButton: 'btn btn-primary me-3',
            cancelButton: 'btn btn-gray',
        },
        buttonsStyling: false,
    })
);

export const KanbanEditModal = (props: any) => {
    const {
        id: cardId,
        index,
        listId,
        show = false,
        attributeForm,
        modalTitle = 'Edit Attribute',
        initialData,
        cardType,
        cityCall,
        isOrgNameExist,
        fontScale,
        _deletemanagerial,
    } = props;
    const [attform, setAttform] = useState(attributeForm);
    // useEffect(()=>setAttform({...attform,attributeForm}),[attributeForm]);
    useEffect(() => {
        let _fields = [];
        _fields = attributeForm?.fields?.map((field) => {
            if (field?.type === 'email')
                return {
                    ...field,
                    compProps: {
                        ...field?.compProps,
                        disabled: true,
                        readOnly: true,
                    },
                };
            else return field;
        });
        console.log('asjlgfasjdf', _fields);
        setAttform({ ...attributeForm, fields: _fields });
    }, [attributeForm]);
    console.log('attributeform', attributeForm, initialData);
    const [title, setTitle] = useState(props.title ?? '');
    const [attributeType, setAttributeType] = useState(
        props.attributeType ?? ''
    );
    const [isRequired, setRequired] = useState(props.isRequired ?? false);
    const [showOptions, setShowOptions] = useState(!!props.attributeOptions);
    const [options, setOptions] = useState<any>(props.attributeOptions ?? '');
    const [_initData, setInitData] = useState(initialData);

    async function isOrgNameExistCall(payload: any) {
        let bool_res = await isOrgNameExist(payload);
        return bool_res;
    }

    const call = async (id: any, payload: any) => {
        const cities = await cityCall('parish', payload);
        let fields = attributeForm.fields.map((item: any, key: any) => {
            if (item?.compProps?.id === 'city') {
                return {
                    ...item,
                    compProps: { ...item.compProps, options: cities.cities },
                };
            } else {
                return { ...item };
            }
        });
        let _flds = fields.map((field) => {
            if (field?.type === 'email')
                return {
                    ...field,
                    compProps: {
                        ...field?.compProps,
                        disabled: true,
                        readOnly: true,
                    },
                };
            else return field;
        });
        setAttform({ ...attributeForm, fields: _flds });
        console.log('citiessss', cities?.cities, fields);
    };
    const format = (type: any, data: any) => {
        let res = {};
        if (type === 'branches') {
            res = {
                name: data?.name ?? undefined,
                address: {
                    addressLine1: data?.addressLine1 ?? undefined,
                    addressLine2: data?.addressLine2 ?? undefined,
                    city: data?.city ?? undefined,
                    parish: data?.parish ?? undefined,
                    zipcode: data?.zipcode ?? undefined,
                },
                contactPerson: data?.contactPerson ?? undefined,
                country: data?.country ?? undefined,
                email: data?.email ?? undefined,
                primaryContactNo: data?.primaryContactNo ?? undefined,
                website: data?.website ?? undefined,
                operation: 'UPDATE',
            };
        }
        if (type === 'directors') {
            res = {
                operation: 'UPDATE',
                email: data?.email ?? undefined,
                firstName: data?.firstName ?? undefined,
                middleName: data?.middleName ?? undefined,
                lastName: data?.lastName ?? undefined,
                isLastNameExist: data?.isLastNameExist === 'yes' ? true : false,
                nationality: data?.nationality ?? undefined,
                occupation: data?.occupation ?? undefined,
                primaryContactNo: data?.primaryContactNo ?? undefined,
            };
        }
        if (type === 'subsidiaries') {
            res = {
                operation: 'UPDATE',
                address: {
                    addressLine1: data?.addressLine1 ?? undefined,
                    addressLine2: data?.addressLine2 ?? undefined,
                    city: data?.city ?? undefined,
                    parish: data?.parish ?? undefined,
                    zipcode: data?.zipcode ?? undefined,
                },
                contactPerson: data?.contactPerson ?? undefined,
                country: data?.country ?? undefined,
                email: data?.email ?? undefined,
                primaryContactNo: data?.primaryContactNo ?? undefined,
                website: data?.website ?? undefined,
                tradingName: data?.tradingName ?? undefined,
            };
        }
        return res;
    };
    useEffect(() => {
        if (initialData['parish'] && cityCall) {
            call('parish', initialData['parish']);
        }
    }, []);
    const onChange = () => {
        const payload = {
            listId,
            cardId,
            title,
            attributeType,
            attributeOptions: options,
            isRequired,
        };
        let hasError = false;
        if (attributeType === 'radio' && !options) {
            hasError = true;
            SwalWithBootstrapButtons.fire({
                icon: 'error',
                title: `No options entered for Selection Attribute`,
                text: `Please enter comma seperated values as options`,
                showCancelButton: false,
                confirmButtonText: 'OK',
            });
        }
        if (!hasError) {
            return props.onChange && props.onChange(payload);
        }
    };

    const onMove = () => {
        props.onMove && props.onMove({ listId, index });
    };
    let enumlist = {
        Director: 'directors',
        Subsidiary: 'subsidiaries',
        Branch: 'branches',
    };
    const onTitleChange = (e: any) => setTitle(e.target.value);
    const onRequiredChange = (e: any) => setRequired(e.target.checked);

    const onOptionsChange = (e: any) => {
        setOptions(e.target.value);
    };
    const onAttributeTypeChange = (e: any) => {
        setAttributeType(e.target.value);
        if (e?.target?.value === 'radio') {
            setShowOptions(true);
        }
    };
    const onHide = () => props.onHide && props.onHide();

    return (
        <Modal
            as={Modal.Dialog}
            centered
            show={show}
            onHide={onHide}
            size={'lg'}
        >
            {/* <Form className="modal-content p-3"> */}
            <Modal.Header className="pb-0 border-0">
                <h5
                    as={Modal.Title}
                    className="fw-normal"
                    style={{ fontSize: '16pt' }}
                >
                    {modalTitle}
                </h5>
                <Button variant="close" onClick={onHide} />
            </Modal.Header>
            <Modal.Body className="pb-0">
                {/* <Form.Group id="title" className="mb-3">
                        <S.FormControl fontScale={fontScale}
                            required
                            autoFocus
                            type="text"
                            value={title}
                            defaultValue={props.titleDefaultValue}
                            onChange={onTitleChange}
                            placeholder={props.titlePlaceholder}
                        />
                    </Form.Group>
                    <Form.Group id="description" className="mb-3">
                        <Form.Select
                            onChange={onAttributeTypeChange}
                            // defaultValue={props.attributeTypeDefaultValue}
                            value={attributeType}
                        >
                            <option>{props.attributeTypePlaceholder}</option>
                            {props.attributeTypeValue?.map(
                                (desc: any, index: number) => (
                                    <option
                                        key={`kanban-create-modal-${desc.value}-${index}`}
                                        value={desc?.value}
                                    >
                                        {desc?.label}
                                    </option>
                                )
                            )}
                        </Form.Select>
                    </Form.Group>
                    {_renderOptionsIf()}
                    <Form.Group id="required" className="mb-3">
                        <Form.Check
                            label={props.requiredLabel}
                            onChange={onRequiredChange}
                            checked={isRequired}
                        />
                    </Form.Group> */}
                <TweetyWidget
                    {...attform}
                    initialData={_initData}
                    fontScale={fontScale}
                    labelColor={'#104382'}
                    onChange={(id, payload) => {
                        console.log(id, payload, _initData, 'pu->up');
                        if (id === 'parish') {
                            setInitData({
                                ..._initData,
                                [id]: payload,
                                city: null,
                            });
                            // call && call(id,initialData[id]);
                        } else {
                            setInitData({ ..._initData, [id]: payload });
                        }
                        // else
                        props?.onDynamicFieldChange &&
                            props?.onDynamicFieldChange(id, payload);
                    }}
                    onUpdateDynamicLayData={(data: any) =>
                        setInitData({ ...data })
                    }
                    renderSubmitButton={() => (
                        <Modal.Footer className="justify-content-start border-0 pt-0">
                            <Button
                                style={{ fontSize: '16pt' }}
                                variant="outline-gray-500"
                                onClick={onHide}
                            >
                                {props.closeButtonLabel}
                            </Button>
                            <Button
                                variant="secondary"
                                className="d-inline-flex align-items-center"
                                type="submit"
                                style={{ fontSize: '16pt' }}
                                //  onClick={onSubmit}
                            >
                                <PencilIcon className="icon icon-xs me-2" />
                                {cardType
                                    ? `Edit ${toHeaderCase(cardType)}`
                                    : modalTitle}
                            </Button>
                        </Modal.Footer>
                    )}
                    onFormSubmit={async (payload) => {
                        if(isOrgNameExist && (cardType === 'Branch' || cardType === 'Subsidiary')) {
                            let bool_result = await isOrgNameExistCall(payload);
                            console.log('Asir pu->', _initData, payload," isOrgNameExist", bool_result.isOrgNameExist);
                            if (bool_result.isOrgNameExist) {
                                SwalWithBootstrapButtons.fire({
                                    icon: 'error',
                                    title: `${cardType} Name Already Exist`,
                                    text: `Please enter a different ${cardType} Name`,
                                    showCancelButton: false,
                                    confirmButtonText: 'OK',
                                });
                                return;
                            }
                        }

                        props?.onChange &&
                            props?.onChange({
                                ...payload,
                                listId,
                                cardId: cardId,
                            });
                        console.log('aehdfaehffej', cardId, props);
                        _deletemanagerial &&
                            _deletemanagerial(
                                enumlist[props?.cardType],
                                format(enumlist[props?.cardType], payload)
                            );
                    }}
                />
            </Modal.Body>
            {/* <Modal.Footer className="justify-content-start border-0 pt-0">
                    <Button variant="outline-gray-500" onClick={onHide}>
                        {props.closeButtonLabel}
                    </Button>
                    <Button
                        variant="secondary"
                        className="d-inline-flex align-items-center"
                        onClick={onChange}
                    >
                        <PencilIcon className="icon icon-xs me-2" />
                        Edit
                    </Button>
                </Modal.Footer> */}
            {/* </Form> */}
        </Modal>
    );
};

KanbanEditModal.defaultProps = {
    requiredLabel: 'Required',
    closeButtonLabel: 'Cancel',
    attributeTypeValue: [],
};
